// Import enumerations.
import {
	Peril,
} from '@app/enumerations';

export default class PerilDeductible {
	public perilCode: Peril | null = null;
	public deductibleCode: string | null = null;

	public constructor() {

	}
};